import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import { request } from "@/utils/api";

// Create entity adapter
const shipmentAdapter = createEntityAdapter({
    // Select MongoDB-style _id as the entity ID
    selectId: (shipment) => shipment._id,
    // Optional default sorting
    sortComparer: (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
});

export const fetchShipmentData = createAsyncThunk(
    "shipment/fetch",
    async (data, { rejectWithValue }) => {
        try {
            const response = await request({
                endpoint: "/user/getUserShipments",
                method: "GET",
                params: data
            });

            console.log("Fetch ShipmentData Response:", response);

            if (!response.success) {
                return rejectWithValue(response.error.message || "Failed to fetch Shipment data.");
            }

            return response.data.shipments;
        } catch ({ error }) {
            console.error("Error fetching shipment data:", error);
            return rejectWithValue(error.message || "An unexpected error occurred while fetching shipment data.");
        }
    }
);
export const cancelShipment = createAsyncThunk(
    "shipment/cancel",
    async (shipmentIds, { rejectWithValue }) => {
        try {
            const response = await request({
                endpoint: "/user/cancelShipment",
                method: "POST",
                body: { shipmentIds },
            });
            console.log("Cancel Shipment Response:", response);

            if (!response.success) {
                return rejectWithValue(response.error.message || "Failed to cancel shipment.");
            }

            return response.data;
        }
        catch ({ error }) {
            console.error("Error canceling shipment:", error);
            return rejectWithValue(error.message || "An unexpected error occurred while canceling shipment.");
        }
    }
);
const initialState = shipmentAdapter.getInitialState({
    loading: false,
    error: null,
});

const shipmentSlice = createSlice({
    name: 'shipment',
    initialState,
    reducers: {
        addShipmentsIO: (state, action) => {
            shipmentAdapter.setAll(state, action.payload);
        },
        upsertShipmentsIO: (state, action) => {
            shipmentAdapter.upsertMany(state, action.payload);
        },
        addShipmentIO: (state, action) => {
            shipmentAdapter.addOne(state, action.payload);
        },
        clearShipmentsIO: (state) => {
            shipmentAdapter.removeAll(state);
            state.loading = false;
            state.error = null;
        },
        updateShipmentIO: (state, action) => {
            shipmentAdapter.updateOne(state, action.payload);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchShipmentData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchShipmentData.fulfilled, (state, action) => {
                shipmentAdapter.setAll(state, action.payload);
                state.loading = false;
            })
            .addCase(fetchShipmentData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(cancelShipment.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(cancelShipment.fulfilled, (state, action) => {
                if (action.payload) {
                    shipmentAdapter.upsertMany(state, action.payload);
                }
                state.loading = false;
            })
            .addCase(cancelShipment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

// Export selectors
export const {
    selectAll: selectAllShipments,
    selectById: selectShipmentById,
    selectIds: selectShipmentIds,
} = shipmentAdapter.getSelectors((state) => state.shipment);

// Export actions
export const { addShipmentsIO, clearShipmentsIO, upsertShipmentsIO, addShipmentIO, updateShipmentIO } = shipmentSlice.actions;
export default shipmentSlice.reducer;